import { useMemo, useState, useEffect } from 'react';
import { Card, Col, Row, Button } from 'react-bootstrap';
import PageTitle from '../../includes/PageTitle';
import Tables from "../../components/Tables/Tables";
import Modals from "../../components/Modals/Modals";
import Alert from 'react-bootstrap/Alert';
import { useFormik } from 'formik';
import { ToastContainer, toast } from 'react-toastify';
import Loader from '../../components/Loader/Loader';
import { postPositionAdd, postPosition, getPositionDetails, deletePosition, patchPositionUpdate } from '../../apiservices/ApiServices';


const Functions = () => {
    const [show, setShow] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [isLoadings, setLoadings] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [data, setData] = useState([]);
    const [isEdit, setIsEdit] = useState(false);

    const postPositions = async (postData) => {
        setLoading(true);
        try {
            const res = await postPosition(postData);
            setData(res.data.data.records);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    const postUpdatePosition = async () => {
        let postData = {
            length: 100
        }
        try {

            const res = await postPosition(postData);
            setData(res.data.data.records);

        } catch (error) {
            toast.error(error.response?.data?.message || "Error submitting data");
        }
    };

    useEffect(() => {
        let postData = {
            length: 100
        }
        postPositions(postData);
    }, []);

    const columns = useMemo(
        () => [
            {
                Header: "Function Name",
                accessor: "name",
            },
            {
                Header: "Designation/Role Count",
                accessor: "designation_count",
            },
            {
                Header: "Action",
                accessor: "action",
                disableSortBy: true,
            },
        ],
        []
    );

    const actions = ['edit', 'delete']
    const subActions = []

    const initialValues = {
        id: '',
        name: '',
        description: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: '',
        onSubmit: async (values) => {
            setLoadings(true);

            let postData = {
                name: values.name,
                description: values.description,
            }

            if (isEdit) {
                try {
                    const res = await patchPositionUpdate(values.id, postData);
                    toast.success(res.data.message);
                    postUpdatePosition();
                    setLoadings(false);
                    setAddModal(false);
                    setIsEdit(false);
                    formik.resetForm();
                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }
            else {
                try {
                    const res = await postPositionAdd(postData);
                    toast.success(res.data.message);
                    postUpdatePosition();
                    setLoadings(false);
                    setAddModal(false);
                    setIsEdit(false);
                    formik.resetForm();
                } catch (error) {
                    setLoadings(false);
                    toast.error(error.response?.data?.message || "Error submitting data");
                }
            }
        },
    });
    const { values, handleChange, handleBlur, handleSubmit, setFieldValue, errors, touched } = formik;

    const handleConfirm = () => {
        setAddModal(false);
        setIsEdit(false);
        formik.resetForm();
    };

    const handleEdit = async (rowData) => {
        setLoadings(true);
        try {
            const res = await getPositionDetails(rowData?.position_id);
            setLoadings(false);
            setIsEdit(true);
            setFieldValue('id', res.data.data.position_id);
            setFieldValue('name', res.data.data.name);
            setFieldValue('description', res.data.data.description);
            setAddModal(true);
        } catch (error) {
            setLoadings(false);
            setIsEdit(false);
            setAddModal(false);
        }
    };

    const handleDelete = (rowData) => {
        setShow(true);
        setFieldValue('id', rowData?.position_id);
        setFieldValue('name', rowData?.name);
    };

    const handleDeleteCon = async () => {
        setLoadings(true);
        try {
            const res = await deletePosition(values.id);
            console.log(res.data)
            toast.success(res.data.message);
            setLoadings(false);
            setShow(false);
            postUpdatePosition();
            setFieldValue('id', '');
            setFieldValue('sectorName', '');
        } catch (error) {
            setLoadings(false);
            setShow(false);
        }
    };

    return (
        <>
            <ToastContainer
                position="top-right"
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                style={{ zIndex: 9999999999, position: 'fixed' }}
            />
            {isLoading ? <Loader /> :
                <>
                    <PageTitle titles="Functions" active="SecFunctionstors" items={['Home']} />
                    <Row>
                        <Col sm={12} className="col-12">
                            <Card>
                                <Card.Body className="example1-table">
                                    <div className='custompageHed'>
                                        <Row>
                                            <Col md={6}>
                                                <div className='pagetitle_hed'>
                                                    <h1>Functions/Department</h1>
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className='w-100 d-flex justify-content-end'>
                                                    <Button variant="primary" onClick={() => setAddModal(true)}>Add New</Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Tables
                                        columns={columns}
                                        data={data}
                                        actions={actions}
                                        subActions={subActions}
                                        onEdit={handleEdit}
                                        onDelete={handleDelete}
                                    />
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }

            <Modals
                show={addModal}
                handleClose={() => setAddModal(false)}
                title={isEdit ? 'Edit' : 'Add'}
                textColor='#000'
                size='lg'
                centered={true}
                backdrop={true}
                onConfirm={handleConfirm}
            >
                <form onSubmit={handleSubmit} autoComplete="off">
                    <Row>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Functions Name</label>
                                <input
                                    type='text'
                                    name="name"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.name && touched.name && (
                                    <p className="errormsg">{errors.name}</p>
                                )}
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="form-group">
                                <label className="form-label">Description</label>
                                <textarea
                                    id="description"
                                    name="description"
                                    className="form-control"
                                    autoComplete='off'
                                    value={values.description}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                />
                                {errors.description && touched.description && (
                                    <p className="errormsg">{errors.description}</p>
                                )}
                            </div>
                        </Col>
                    </Row>
                    <div className='modalfooters'>
                        <div className='button-boxs grid'>
                            <button type='submit' className='btn btn-primary'>{isEdit ? 'Update' : 'Save'}</button>
                            <button type='button' onClick={handleConfirm} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </form>
            </Modals>

            {show ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure want to Delete <span>{values.sectorName}</span> Functions/Department?</Alert.Heading>
                    <hr />
                    <div className='button-boxs grid'>
                        <div>
                            <button onClick={() => handleDeleteCon()} className='btn btn-primary'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-default'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}

            {isLoadings && <Loader />}
        </>
    )
}

export default Functions